<template>
  <header class="ren-decoration-cp ren-decoration-cp-title" :style="titleStyle">
    <div>
      <strong>{{ title }}</strong>
      <small v-if="subtitle">{{ subtitle }}</small>
    </div>
    <span v-if="showMore">更多</span>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const title = computed(() =>
  stringValue(props.component.props?.title, props.component.title || '区块标题')
)
const subtitle = computed(() => stringValue(props.component.props?.subtitle).trim())
const showMore = computed(() => booleanValue(props.component.props?.showMore, false))
const titleStyle = computed(() => {
  const style = props.component.style ?? {}
  const alignValue = String(style.align ?? 'LEFT').toUpperCase()
  const textAlign = alignValue === 'CENTER' ? 'center' as const : alignValue === 'RIGHT' ? 'right' as const : 'left' as const
  const fontSize = Number(style.fontSize)
  const color = stringValue(style.textColor)
  return {
    textAlign,
    color: color || undefined,
    fontSize: Number.isFinite(fontSize) && fontSize > 0 ? `${fontSize}px` : undefined
  }
})
</script>

<style scoped>
.ren-decoration-cp-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.ren-decoration-cp-title div {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.ren-decoration-cp-title strong,
.ren-decoration-cp-title small {
  overflow-wrap: anywhere;
}

.ren-decoration-cp-title small,
.ren-decoration-cp-title span {
  color: var(--ren-theme-muted);
  font-size: 12px;
}
</style>
